import { computed } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';

export function useCustomSettings() {
  const getters = useStoreGetters();
  const customSettings = computed(() => getters.getCustomSettings.value);

  return {
    customSettings,
  };
}
